import { TradingErrorView } from '@trading-ui/custom';
import { useNavigate } from 'react-router-dom';

import { appRoutes } from '../../config/appRoutes';

interface ErrorViewProps {
  label?: string;
  errorCode: number | string;
  onButtonClick?: () => void;
}

export default function ErrorView({ label, errorCode, onButtonClick }: Readonly<ErrorViewProps>) {
  const navigate = useNavigate();

  const action = () => {
    if (onButtonClick) onButtonClick();
    else navigate(appRoutes.HOME);
  };

  return <TradingErrorView label={label} action={action} errorCode={errorCode} isExternal />;
}
